import { withStorage, UNAVAILABLE, serverFetchAllBadges } from '../data/storage.js';
import { dispatchScan } from '../features/scan.js';

const searchInputEl = document.getElementById('checkin-search-input');
const searchTriggerEl = document.getElementById('checkin-search-trigger');
const searchResultEl = document.getElementById('checkin-search-result');

export const SEARCH = {
    badges: [],
    offlineUnavail: false,
    async init() {
        // Prefer IDB when offline mode enabled; otherwise use server if online.
        const res = await withStorage(
            db => db.getAll('badges'),
            () => serverFetchAllBadges(),
            { offlineMessage: 'Local DB not available. This page can only work with the device online.', notify: false }
        );

        if (res === UNAVAILABLE) {
            this.badges = [];
            this.offlineUnavail = true;
        } else {
            this.badges = Array.isArray(res) ? res : [];
            this.offlineUnavail = false;
        }

        if (searchInputEl && searchTriggerEl) {

            searchTriggerEl.addEventListener('click', function () {
                SEARCH.render();
            });

            searchInputEl.addEventListener('keydown', (e) => {
                if (e.key === 'Enter') {
                    e.preventDefault();
                    SEARCH.render();
                }
            });

            let typingTimer;
            searchInputEl.addEventListener('input', function () {
                // debounce 500ms
                clearTimeout(typingTimer);
                typingTimer = setTimeout(() => {
                    SEARCH.render();
                }, 500);
            });

        }

    },
    reset() {
        if (searchInputEl && searchResultEl) {
            searchInputEl.value = '';
            searchResultEl.innerHTML = '';
        }
    },
    render() {
        if (searchInputEl && searchTriggerEl && searchResultEl) {

            const cleaned_kw = searchInputEl.value.trim().toLowerCase();

            if (cleaned_kw.length < 3) {
                searchResultEl.innerHTML = '';
                return;
            }

            if (this.offlineUnavail && !navigator.onLine) {
                searchResultEl.innerHTML = `
                    <div class="card">
                        <div class="card-body">
                            <div class="text-center">
                                Local DB not available. This page can only work with the device online.
                            </div>
                        </div>
                    </div>
                `;
                return;
            }

            const filtered = this.badges.filter(b => (b.name && b.name.toLowerCase().includes(cleaned_kw))
                || (b.company && b.company.toLowerCase().includes(cleaned_kw)));

            let html = '';

            if (filtered.length) {

                html = '<div class="table-responsive"><table class="table table-sm table-nowrap card-table"><tbody>';

                html += filtered.map(b => {
                    let statusEl = '';

                    if (b.is_allowed) {
                        statusEl = b.scan_count > 0 ? '<span class="badge bg-success"><span class="bi bi-check"></span></span>' : '<span class="badge bg-warning"><span class="bi bi-exclamation-circle"></span></span>';
                    } else {
                        statusEl = '<span class="badge bg-danger"><span class="bi bi-exclamation-triangle"></span></span>';
                    }

                    return `
                        <tr>
                            <td width="20" class="align-middle text-center">
                                ${statusEl}
                            </td>
                            <td class="align-middle text-start">
                                <button type="button" class="btn-action-proceed btn btn-link px-0" data-uuid="${b.uuid}">${b.name}</button>
                            </td>
                            <td class="align-middle text-start"> ${b.company ?? ''}</td>
                        </tr>
                    `;
                }).join('');

                html += '</tbody></table></div>';

            } else {

                html = '<div class="card"> <div class="card-body"> <div class="text-center"> No results </div> </div> </div>';

            }

            searchResultEl.innerHTML = html;

            const buttons_action_proceed = searchResultEl.querySelectorAll('button[data-uuid].btn-action-proceed');

            buttons_action_proceed.forEach(btn => {
                const uuid = btn.getAttribute('data-uuid');
                btn.addEventListener('click', () => {
                    dispatchScan({ data: uuid, type: 'SEARCH' });
                });
            });

        }
    }
};